import script from "./BaseSnackbarContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSnackbarContainer.vue?vue&type=script&setup=true&lang=js"

import "./BaseSnackbarContainer.vue?vue&type=style&index=0&id=7a36f6e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a36f6e6"]])

export default __exports__